import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=9ba09b84&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=9ba09b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba09b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba09b84')) {
      api.createRecord('9ba09b84', component.options)
    } else {
      api.reload('9ba09b84', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=9ba09b84&scoped=true&", function () {
      api.rerender('9ba09b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/CookieBox.vue"
export default component.exports